import {
    AfterViewInit,
    Component,
    HostListener,
    Inject,
    Input,
    OnInit,
    Optional,
} from '@angular/core';
import { AuthenticationService } from '../@core/authentication/authentication.service';
import { RouteExecutor } from '../@core/application-router/route.executor';
import { ApplicationRouterService } from '../@core/application-router/application-router.service';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { FooterPageService } from '../footer/footer-page.service';

@Component({
    selector: 'app-auth-page',
    templateUrl: './auth-page.component.html',
    styleUrls: ['./auth-page.component.scss'],
})
export class AuthPageComponent
    extends RouteExecutor
    implements OnInit, AfterViewInit
{
    isPagePopup = false;
    loading = false;
    wrongNumber = '';
    innerWidth: any;
    @Input() filter: { [p: string]: string | string[] } = {};

    identifier: FormControl | null = null;
    authConfig: {
        mechanism: {
            label: string;
            prefix: string;
            pattern: string;
            type: string;
            maxLength: string;
        };
    };

    constructor(
        private authenticationService: AuthenticationService,
        applicationRouterService: ApplicationRouterService,
        private activatedRoute: ActivatedRoute,
        @Optional() public dialogRef: MatDialogRef<AuthPageComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public dataDialog: any,
        private footerService: FooterPageService
    ) {
        super(applicationRouterService);
        this.authConfig = this.authenticationService.getAuthConfig();
        if (!!dataDialog?.popup) {
            this.isPagePopup = true;
            this.filter = dataDialog.query;
        } else {
            this.processLink('/fn/internal?page=ap&action=nav-update');
            this.activatedRoute.queryParams.subscribe(param => {
                this.filter = param;
                this.footerService.updateFilter({ ...this.filter, page: 'ap' });
            });
        }
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        this.innerWidth = event.target.innerWidth;
    }

    ngOnInit(): void {
        this.identifier = new FormControl('', Validators.required);
        this.innerWidth = window.innerWidth;
    }

    ngAfterViewInit(): void {
        window.scrollTo(0, 0);
    }

    async executeFunctionLink(
        id: string,
        query: { [p: string]: string | string[] }
    ) {
        // noinspection JSRedundantSwitchStatement
        switch (query?.action) {
            case 'generate-otp':
                {
                    this.loading = true;
                    await this.authenticationService.generateOTP(
                        (this.authConfig.mechanism.prefix as string) +
                            this.identifier?.value.toString()
                    );
                    const popup =
                        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                            navigator.userAgent
                        )
                            ? false
                            : false;
                    if (!!this.filter.f && !!this.filter.s) {
                        this.processLink(
                            `/ap/verify?f=${this.filter.f}&s=${this.filter.s}&refresh=false&transient=true&transition=auto&popup=${popup}`
                        );
                    } else if (!!this.filter.f) {
                        this.processLink(
                            `/ap/verify?f=${this.filter.f}&refresh=false&transient=true&transition=auto&popup=${popup}`
                        );
                    } else if (!!this.filter.s) {
                        this.processLink(
                            `/ap/verify?s=${this.filter.s}&refresh=false&transient=true&transition=auto&popup=${popup}`
                        );
                    } else {
                        this.processLink(
                            `/ap/verify?&refresh=false&transient=true&transition=auto&popup=${popup}`
                        );
                    }
                }

                break;
            case 'nav-update':
                {
                    this.applicationRouterService
                        .executeFunctionLink(id, query)
                        .subscribe(res => {
                            res.data.redirects?.forEach((link: string) => {
                                this.processLink(link);
                            });
                        });
                }
                break;
        }
    }

    backButton() {
        window.history.back();
    }
    // Only Integer Numbers
    keyPressNumbers(
        event: {
            which: any;
            keyCode: any;
            preventDefault: () => void;
        },
        type: string
    ) {
        if (type == 'tel') {
            var charCode = event.which ? event.which : event.keyCode;
            // Only Numbers 0-9
            if (charCode < 48 || charCode > 57) {
                event.preventDefault();
                return false;
            } else {
                this.wrongNumber = 'Please enter valid number';
                return true;
            }
        }
        if (type == 'email') {
            this.wrongNumber = 'Please enter valid email address';
        }
    }
}
